import styled from 'styled-components';

export const EasyBoardingContainer = styled.div`
    margin: ${p => p.margin ? p.margin : ''};
    h4 {
        margin-bottom: 1.3rem;
    }
    img {
        height: 98px;
        width: 98px;
    }
    .points {
        background-color: #e1e7ee;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;

        p {
            color: #647a97;
        }
    }
`;